export const OE_DATA_ORGANIZATIONS_COLUMN_NAME_TEXT = {
    id: 'oe.oeDataOrganizations.column.name',
    defaultMessage: 'Name',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_SHORT_NAME_TEXT = {
    id: 'oe.oeDataOrganizations.column.shortName',
    defaultMessage: 'Short Name',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_ORGANIZATION_TYPE_TEXT = {
    id: 'oe.oeDataOrganizations.column.organizationType',
    defaultMessage: 'Type',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_PARENT_ORGANIZATION_TEXT = {
    id: 'oe.oeDataOrganizations.column.parentOrganization',
    defaultMessage: 'Parent Organization',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_HQ_TEXT = {
    id: 'oe.oeDataOrganizations.column.hq',
    defaultMessage: 'HQ',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_HQ_CITY_TEXT = {
    id: 'oe.oeDataOrganizations.column.hqCity',
    defaultMessage: 'HQ City',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_HQ_COUNTRY_TEXT = {
    id: 'oe.oeDataOrganizations.column.hqCountry',
    defaultMessage: 'HQ Country',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_WEBSITE_TEXT = {
    id: 'oe.oeDataOrganizations.column.website',
    defaultMessage: 'Website',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_NOTES_TEXT = {
    id: 'oe.oeDataOrganizations.column.notes',
    defaultMessage: 'Notes',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_CREATED_AT_TEXT = {
    id: 'oe.oeDataOrganizations.column.createdAt',
    defaultMessage: 'Created',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_UPDATED_AT_TEXT = {
    id: 'oe.oeDataOrganizations.column.updatedAt',
    defaultMessage: 'Updated',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_TICKER_TEXT = {
    id: 'oe.oeDataOrganizations.column.ticker',
    defaultMessage: 'Ticker',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_EXCHANGE_TEXT = {
    id: 'oe.oeDataOrganizations.column.exchange',
    defaultMessage: 'Exchange',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_ISIN_TEXT = {
    id: 'oe.oeDataOrganizations.column.isin',
    defaultMessage: 'ISIN',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_MARKET_CAP_TEXT = {
    id: 'oe.oeDataOrganizations.column.marketCap',
    defaultMessage: 'Market Cap',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_MARKET_CAP_CURRENCY_TEXT = {
    id: 'oe.oeDataOrganizations.column.marketCapCurrency',
    defaultMessage: 'Market Cap Currency',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_SECTOR_TEXT = {
    id: 'oe.oeDataOrganizations.column.sector',
    defaultMessage: 'Sector',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_INDUSTRY_TEXT = {
    id: 'oe.oeDataOrganizations.column.industry',
    defaultMessage: 'Industry',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_FISCAL_YEAR_END_TEXT = {
    id: 'oe.oeDataOrganizations.column.fiscalYearEnd',
    defaultMessage: 'Fiscal Year End',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_IR_WEBSITE_TEXT = {
    id: 'oe.oeDataOrganizations.column.irWebsite',
    defaultMessage: 'IR Website',
    description: 'Column name',
};

export const OE_DATA_ORGANIZATIONS_COLUMN_ACTIVE_STATUS_TEXT = {
    id: 'oe.oeDataOrganizations.column.activeStatus',
    defaultMessage: 'Status',
    description: 'Column name',
};

export const NO_OE_DATA_ORGANIZATIONS_MESSAGE_TEXT = {
    id: 'oe.oeDataOrganizations.noOrganizationsMessage',
    defaultMessage: 'No organizations found.',
    description: 'Message displayed when there are no OE Data organizations',
};
